import React from 'react';
import { Box, Grid, TextField, Typography } from '@mui/material';
import { EventReviewProps } from '../EventReview';
import { Editor } from '../../../components/Editor/Editor';
import { SelectEventType } from '../../../components/SelectEventType/SelectEventType';
import { Event, EventStatus, EventType } from '../../../services/Types';
import { usePermissions } from '../../../hooks/usePermissions';
import { useEventValidation } from '../../../contexts/EventValidationContext';
import { getStatusLabel } from '../../../helpers/statusColors';

export const EventInfoReview: React.FC<EventReviewProps> = ({ eventData, handleEventChange }) => {
  const { userIsAdmin, userIsApprover, eventIsUnlocked } = usePermissions(eventData || {} as Event);
  const { isFieldEnabled } = useEventValidation();

  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <SelectEventType
          value={eventData?.eventType || EventType.WEBINAR}
          disabled={!isFieldEnabled(!userIsAdmin)}
          onChange={(eventType: string) => {
            const syntheticEvent = {
              target: { value: eventType as EventType }
            } as unknown as React.ChangeEvent<HTMLInputElement>;
            handleEventChange('eventType')(syntheticEvent);
          }}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          select
          label="Status"
          value={eventData?.status || EventStatus.SAVED}
          onChange={handleEventChange('status')}
          SelectProps={{
            native: true,
          }}
          disabled={!isFieldEnabled(!userIsAdmin)}
          fullWidth
        >
          {Object.values(EventStatus).map((status: EventStatus) => (
            <option key={status} value={status}>
              {getStatusLabel(status)}
            </option>
          ))}
        </TextField>
      </Grid>

      <Grid item xs={12}>
        <TextField
          label="Title"
          value={eventData?.title || ''}
          onChange={handleEventChange('title')}
          disabled={!isFieldEnabled(!eventIsUnlocked)}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label="Summary"
          value={eventData?.summary || ''}
          onChange={handleEventChange('summary')}
          multiline
          rows={4}
          inputProps={{ maxLength: 500 }}
          disabled={!isFieldEnabled(!eventIsUnlocked)}
        />
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Typography variant="caption" color="textSecondary">
            {(eventData?.summary?.toString() || '').length} / 500
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={12}>
        <label>Description</label>
        <Editor
          setEditorText={(text: string) => {
            const syntheticEvent = {target: {value: text}} as React.ChangeEvent<HTMLInputElement>;
            handleEventChange('description')(syntheticEvent);
          }}
          validationField="description"
          editorText={eventData?.description}
          style={{ borderRadius: '8px', padding: '8px' }}
          placeholder='Enter Description'
          maxLength={2500}
          disabled={!isFieldEnabled(!eventIsUnlocked)}
        />
      </Grid>
    </Grid>
  );
}; 